import getStrings from "getStrings"
import React  from "react"


class TeacherSignUpUsefulness extends React.Component {
    render() {
        const strings = getStrings()

        return (
            <section className='schoolzone-useful'>
                <img className='schoolzone-useful--bg' src={'/images/Ghost_Illustration.png'} alt='' />
                <div className='container flex-row justify-end'>
                    <div className='schoolzone-useful--text margin-right-1 margin-left-1'>
                        <h1>{strings.TEACHER_USEFULNESS_TITLE}</h1>
                        <p>{strings.TEACHER_USEFULNESS_P1}</p>
                        <p>{strings.TEACHER_USEFULNESS_P2}</p>
                        <p>{strings.TEACHER_USEFULNESS_P3}</p>
                    </div>
                </div>
            </section>
        )
    }
}

export default TeacherSignUpUsefulness
